import { render, staticRenderFns } from "./ChartBarPlus.vue?vue&type=template&id=87240438&scoped=true"
import script from "./ChartBarPlus.vue?vue&type=script&lang=js"
export * from "./ChartBarPlus.vue?vue&type=script&lang=js"
import style0 from "./ChartBarPlus.vue?vue&type=style&index=0&id=87240438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87240438",
  null
  
)

export default component.exports